class statisticsPurchaseRankDetailCtrl {
    constructor($scope, httpRequest, $state) {
        // 字典数据
        $scope.dictData = {}
        const typecodeArr = ['is_red', 'ivat_invoice_status', 'ivat_inv_type']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        const invObj = JSON.parse($state.params.params)
        $scope.param = {
            pageNum: 0,
            pageSize: 10,
            param: {
                custCreditCode: invObj.custCreditCode,
                custName: invObj.custName,
                invoiceDateBegin: invObj.invoiceDateBegin,
                invoiceDateEnd: invObj.invoiceDateEnd,
                invoiceType: invObj.invoiceType,
                saleName: invObj.saleName,
                accessToken: localStorage.id_token,
                saleCreditCode: invObj.saleCreditCode,
            },
        }

        // 导出
        $scope.exportInvoic = function () {
            httpRequest.post_selectPurchaseInfoDetail($scope.param.param)
        }

        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        queryInfo()

        $scope.pageChanged = function () { // 点击页码发起查询
            queryInfo()
        }

        function queryInfo() {
            const req = {
                // 传入前台的分页数据
                pageNum: $scope.currentPage,
                pageSize: $scope.maxSize,
                param: {
                    custCreditCode: $scope.param.param.custCreditCode,
                    custName: $scope.param.param.custName,
                    invoiceDateBegin: $scope.param.param.invoiceDateBegin,
                    invoiceDateEnd: $scope.param.param.invoiceDateEnd,
                    invoiceType: $scope.param.param.invoiceType,
                    saleName: $scope.param.param.saleName,
                    saleCreditCode: $scope.param.param.saleCreditCode,
                },
            }
            httpRequest.post_selectPurchaseInfoDetail(req).then((res) => {
                $scope.listData = res.data.value.list

                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.currentPage = ++res.data.value.prePage
                $scope.maxSize = res.data.value.pageSize
            })
        }

        $scope.toCheckPage = function (item) {
            $state.go('statistics.inputStatistics.statisticsPurchaseRank.detail', {
                type: 'orgId',
                id: JSON.stringify({
                    invType: item.invType, invoiceMonth: item.invoiceMonth, orgId: item.invoiceOrgId, cancelStatus: item.cancelStatus, isRed: item.isRed,
                }),
            })
        }
    }
}
statisticsPurchaseRankDetailCtrl.$inject = ['$scope', 'httpRequest', '$state']
export default statisticsPurchaseRankDetailCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/statisticsPurchaseRank/statisticsPurchaseRankDetailCtrl.js